import React from 'react';

export function VerticalDivider() {
  return <span className='border-start pb-2' />;
}
